import {Timezone} from './timezone';

export const TIMEZONES: Timezone[] = [
  {name: 'American Samoa', display: 'SST – American Samoa'},
  {name: 'Hawaii', display: 'HST – Hawaii Standard Time'},
  {name: 'Alaska', display: 'AT – Alaska Time'},
  {name: 'Pacific Time (US & Canada)', display: 'PT – Pacific Time'},
  {name: 'Chihuahua', display: 'MDT – Mountain Daylight Time'},
  {name: 'Mountain Time (US & Canada)', display: 'MT – Mountain Time'},
  {name: 'Central Time (US & Canada)', display: 'CT – Central Time'},
  {name: 'Eastern Time (US & Canada)', display: 'ET – Eastern Time'},
  {name: 'Lima', display: 'PET – Peru Time'},
  {name: 'Quito', display: 'ECT – Ecuador Time'},
  {name: 'Caracas', display: 'VET – Venezuelan Standard Time'},
  {name: 'Atlantic Time (Canada)', display: 'AT – Atlantic Time'},
  {name: 'Newfoundland', display: 'NST – Newfoundland Standard Time'},
  {name: 'Brasilia', display: 'BT – Brazil Time'},
  {name: 'Buenos Aires', display: 'ART – Argentina Time'},
  {name: 'Greenland', display: 'WGT – West Greenland Time'},
  {name: 'Montevideo', display: 'UYT – Uruguay Time'},
  {name: 'Santiago', display: 'CT – Chile Time'},
  {name: 'Mid-Atlantic', display: 'FNT – Fernando de Noronha Time'},
  {name: 'Azores', display: 'AZOST – Azores Standard Time'},
  {name: 'Cape Verde Is.', display: 'CVT – Cape Verde Time'},
  {name: 'Dublin', display: 'IST – Irish Standard Time'},
  {name: 'Lisbon', display: 'WEST – Western European Time'},
  {name: 'UTC', display: 'GMT – Greenwich Mean Time'},
  {name: 'Amsterdam', display: 'CET – Central European Time'},
  {name: 'Athens', display: 'EET – Eastern European Time'},
  {name: 'Baghdad', display: 'AST – Arabia Standard Time'},
  {name: 'Minsk', display: 'FET – Further-Eastern European Time'},
  {name: 'Moscow', display: 'MSK – Moscow Standard Time'},
  {name: 'Nairobi', display: 'EAT – East Africa Time'},
  {name: 'Tehran', display: 'IT – Iran Time'},
  {name: 'Abu Dhabi', display: 'GST – Gulf Standard Time'},
  {name: 'Baku', display: 'AZT – Azerbaijan Time'},
  {name: 'Tbilisi', display: 'GET – Georgia Standard Time'},
  {name: 'Yerevan', display: 'AMT – Armenia Time'},
  {name: 'Kabul', display: 'AFT – Afghanistan Time'},
  {name: 'Ekaterinburg', display: 'YEKT – Yekaterinburg Time'},
  {name: 'Islamabad', display: 'PKT – Pakistan Time'},
  {name: 'Tashkent', display: 'UZT – Uzbekistan Time'},
  {name: 'Chennai', display: 'IT – India Time'},
  {name: 'Kathmandu', display: 'NPT – Nepal Time'},
  {name: 'Almaty', display: 'ALMT – Alma-Ata Time'},
  {name: 'Dhaka', display: 'BST – Bangladesh Standard Time'},
  {name: 'Novosibirsk', display: 'NOVT – Novosibirsk Time'},
  {name: 'Rangoon', display: 'MMT – Myanmar Time'},
  {name: 'Bangkok', display: 'ICT – Indochina Time'},
  {name: 'Jakarta', display: 'WIB – Western Indonesian Time'},
  {name: 'Krasnoyarsk', display: 'KRAT – Krasnoyarsk Time'},
  {name: 'Beijing', display: 'CST – China Standard Time'},
  {name: 'Hong Kong', display: 'HKT – Hong Kong Time'},
  {name: 'Irkutsk', display: 'IRKT – Irkutsk Time'},
  {name: 'Kuala Lumpur', display: 'MYT – Malaysia Time'},
  {name: 'Perth', display: 'AWT – Australian Western Time'},
  {name: 'Singapore', display: 'SGT – Singapore Time'},
  {name: 'Ulaanbaatar', display: 'ULAT – Ulaanbaatar Time'},
  {name: 'Seoul', display: 'KT – Korea Time'},
  {name: 'Tokyo', display: 'JST – Japan Standard Time'},
  {name: 'Yakutsk', display: 'YAKT – Yakutsk Time'},
  {name: 'Adelaide', display: 'ACT – Australian Central Time'},
  {name: 'Guam', display: 'GST – Guam Standard Time'},
  {name: 'Magadan', display: 'MAGT – Magadan Time'},
  {name: 'Port Moresby', display: 'PGT – Papua New Guinea Time'},
  {name: 'Sydney', display: 'AET – Australian Eastern Time'},
  {name: 'Vladivostok', display: 'VLAT – Vladivostok Time'},
  {name: 'New Caledonia', display: 'NCT – New Caledonia Time'},
  {name: 'Solomon Is.', display: 'SBT – Solomon Island Time'},
  {name: 'Auckland', display: 'NZST – New Zealand Standard Time'},
  {name: 'Fiji', display: 'FJT – Fiji Time'},
  {name: 'Kamchatka', display: 'PETT – Kamchatka Time'},
  {name: 'Marshall Is.', display: 'MHT – Marshall Islands Time'},
  {name: 'Chatham Is.', display: 'CHAST – Chatham Island Standard Time'},
  {name: 'Nuku alofa', display: 'TOT – Tonga Time'},
  {name: 'Samoa', display: 'SST – Samoa Standard Time'},
  {name: 'Tokelau Is.', display: 'TKT – Tokelau Time'},
];
